<template>
  <TemplateHead :config="config" />

  <div :class="fonts[config.style.font]">
    <div
      class="w-full flex justify-center shadow-md"
      :style="{
        backgroundColor: `#${primaryColor}`,
      }"
    >
      <div class="w-[80rem] py-2 text-white text-lg font-bold">
        <img
          v-if="config.header?.logo_url"
          class="h-8 object-contain"
          :src="config.header?.logo_url"
          alt="Logo"
        >
        <img
          v-else-if="isPreview()"
          class="h-8 object-contain"
          src="https://placehold.co/190x60"
          alt="Logo"
        >
      </div>
    </div>

    <div class="w-full h-full pb-16 px-4">
      <div class="py-8 px-4 underline">
        <p
          class="underline w-min cursor-pointer"
          @click="router.get(pageBackUrl('PRE-LANDER-002'))"
        >
          {{ __('label_back') }}
        </p>
      </div>

      <div class="flex justify-center">
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="w-[80rem] py-8"
          v-html="page.text"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>

    <Footer
      :pages="pages"
      :collector-flow-uuid="collectorFlowUuid"
      :config="config"
    />
  </div>
</template>

<script setup>
import {defineProps, ref} from 'vue';
import Footer from '@timon/js/Templates/PRE-LANDER-002/Components/Footer.vue';
import {router} from '@inertiajs/vue3';
import TemplateHead from '@timon/js/Components/TemplateHead.vue';
import {isPreview, pageBackUrl} from '@timon/js/Mixins/helpers';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  variables: {
    type: Object,
    required: true,
  },

  collectorFlowUuid: {
    type: String,
    required: true,
  },

  page: {
    type: Object,
    required: true,
  },

  pages: {
    type: Array,
    required: true,
  },
});

const fonts = {
  'mono': 'font-mono',
  'sans': 'font-sans',
  'serif': 'font-serif',
};

const primaryColor = ref(props.config.style?.primary);
</script>
